import { Card } from '@mui/material';
import styled from '@emotion/styled';
import { shouldForwardProps } from '../../utils';

const ContactInfoContainer = styled(Card, shouldForwardProps)`
    height: auto;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    padding: ${({ theme }) => theme.spacing(4)};
    gap: ${({ theme }) => theme.spacing(1)};
    overflow: hidden;
    background-color: ${({ theme }) => theme.colors.outlineVariant};
    border-radius: 4px;
`;

export { ContactInfoContainer };
